import { FC } from 'react';
import { NEW_TAB_ATTRIBUTES, SERVICE_FEES } from 'src/common/constants';
import styles from 'src/content/ContentPages.module.scss';

const MemberAgreement: FC = () => (
  <main className={styles.root}>
    <h1 className={styles.title}>Member Interface Agreement</h1>
    <h2 className={styles.subTitle}>EFFECTIVE AUGUST 26 2025</h2>
    <p>
      For good and valuable consideration, the receipt and sufficiency of which is hereby
      acknowledged, Member agrees to the terms and conditions of this Member Interface Agreement
      (this &quot;Agreement&quot;) as set forth below; to the Terms of Use Agreement (the
      &quot;Terms of Use&quot;) and to the Privacy Policy that are posted on the Getmyboat Website,
      each of which may be revised or updated by Getmyboat from time to time and current copies of
      which can be accessed at: www.getmyboat.com.
    </p>
    <p>
      Member Relationship with Getmyboat. This Agreement sets forth the Terms and Conditions of
      Member&apos;s use of Getmyboat&apos;s products, software, services and web Website(s)
      (collectively &quot;Services&quot;). Getmyboat means Getmyboat, Inc. d/b/a Getmyboat and
      Getmyboat.com. (Getmyboat and Member are referred to herein each as a &quot;Party,&quot; and
      collectively as the &quot;Parties.&quot;) If Member does not agree to all of the Terms, Member
      must not use Getmyboat&apos;s Services. Getmyboat reserves the right to deny use of its
      Services to anyone at any time for any reason. Failure to comply with the Terms may result in
      denial of access to Getmyboat&apos;s Services and cancellation of Member&apos;s Getmyboat
      account.
    </p>
    <h3>Definitions</h3>
    <p>
      &quot;Customer&quot;, &quot;Renter&quot;, or &quot;User&quot; mean a person or organization
      that purchases Rentals from Member with the assistance of Getmyboat&apos;s Services.
      &quot;Getmyboat Website&quot;, or &quot;Website&quot; mean the World Wide Web Website owned by
      Getmyboat and which has the URL www.Getmyboat.com and any and all other web Websites owned or
      operated by Getmyboat over which Getmyboat offers online advertisement services.
      &quot;Member&quot;, or &quot;you&quot; mean any registered user of Getmyboat&apos;s Services
      that uploads boat rental solicitations and any related information to Getmyboat&apos;s Web
      Website for the purposes of holding out and offering boat rentals or boat rental services
      through the Getmyboat Website. Members include any party involved in offering or providing
      boat rentals to Getmyboat Users. &quot;Terms&quot; means this Agreement, the Terms of Use and
      the Privacy Policy.
    </p>
    <p>
      Order of Precedence with respect to Getmyboat Terms. The provisions of this Agreement are
      supplemented by the Terms of Use and the Privacy Policy (a current copy of which can be
      accessed at: www.getmyboat.com), which are incorporated herein by reference. (As noted herein,
      Getmyboat may revise or update the Terms of Use from time to time.) The Parties&apos;
      relationship under this Agreement is governed by the provisions of this Agreement and the
      Terms of Use, except that the terms of this Agreement take precedence over any conflicting or
      contradictory provisions in the Terms of Use.
    </p>
    <p>
      <strong>Acceptance. </strong>
      Use of Getmyboat Services constitutes acceptance of this Agreement. Member accepts the Terms
      and Conditions of this Agreement by: (i) clicking to accept or agree to the Terms and
      Conditions, where this option is made available by Getmyboat in the user interface for any
      Service; or, (ii) by actually using the Services. In the case of (ii), Member understands and
      agrees that its use of the Services constitutes and denotes acceptance of this Agreement,
      including all of its Terms and Conditions, from that time onward.
    </p>
    <p>
      <strong>Website Uptime and Display of Member-Generated Content. </strong>
      Uptime. Getmyboat will use commercially reasonable efforts to ensure that interfaces to Member
      and User access to Getmyboat Services are available without interruption, except for any
      scheduled down time needed to maintain the effective operation of the Getmyboat Website and
      when service interruptions are caused by conditions outside of Getmyboat&apos;s control.
      Getmyboat in no way guarantees that Services will be available without interruption.
    </p>
    <p>
      <strong>Member-Generated Content. </strong>
      You understand that all messages, text, postings, files, photos, images or other materials
      (the &quot;Content&quot;) you post on, transmit through, or link from the Website, are your
      sole responsibility. You agree that Getmyboat is only acting as a passive conduit for your
      online distribution and publication of your Content. More specifically, you are entirely
      responsible for each individual item of the Content that you make available via the Website.
      Getmyboat makes no representation or warranty as to the authenticity, accuracy or completeness
      of the information contained on the Website. In submitting Content, you represent and warrant
      that you have sufficient authority and rights to post such Content, and to grant Getmyboat the
      rights to use such Content in connection with providing the services.
    </p>
    <p>
      Getmyboat is not responsible for any inaccuracy or incompleteness in the information provided
      by Member. It is the Member&apos;s obligation to ensure the accuracy of all listing Content
      (accuracy of boat description, seaworthiness of boat, qualifications of captain, legal
      requirements, identification requirements for renters, insurance, etc.). If Member discovers
      that listing details are inaccurate or incorrect, it is the Member&apos;s sole responsibility
      to correct the information in the Member account interface or contact a Getmyboat
      representative to resolve any such error.
    </p>
    <p>
      We may, without notice to you, suspend or cancel your listing at any time even without
      receiving notice from you or giving notice to you if we suspect, in our sole discretion, that
      your account with us or your email account is being used in an unauthorized or fraudulent
      manner.
    </p>
    <p>
      Posting any Content that Getmyboat deems threatening, defamatory, infringing, unlawful,
      abusive, obscene, vulgar, indecent, inflammatory, sexually explicit, pornographic, profane,
      libelous, harassing, or otherwise objectionable is prohibited. You also agree to not post
      Content that violates any third-party rights, including any Intellectual Property Rights,
      rights of publicity and privacy. Getmyboat reserves the right to remove Content at its sole
      discretion.
    </p>
    <p>
      <strong>License. </strong>
      You retain all your rights in your Content. By posting such Content you grant Getmyboat an
      irrevocable, sub-licensable, transferable, perpetual, non-exclusive, royalty-free, worldwide
      license to use, duplicate, modify, publish, list information regarding, alter, translate,
      distribute, publicly perform, publicly display, and make derivative works of, all such Content
      and your name, voice and/or likeness as contained in your Content, in whole or in part, and in
      any form, media or technology now known or developed in the future for use in Getmyboat&apos;s
      (and its successors&apos; and affiliates&apos;) business. You also hereby grant each User of
      the Service a non-exclusive license to access your Content through the Service, and to use,
      reproduce, distribute, display and perform such Content as permitted through the use of
      Getmyboat&apos;s Service.
    </p>

    <h3>Copyright Policy &amp; DMCA Notice of Alleged Infringement</h3>

    <p>
      <strong>Notification of Copyright Infringement</strong>
    </p>

    <p>
      Getmyboat, Inc. (&quot;Getmyboat&quot;) respects the intellectual property rights of others
      and expects its users to do the same.
    </p>

    <p>
      It is Getmyboat&apos;s policy, in appropriate circumstances and at its discretion, to disable
      and/or terminate the account or access of users who repeatedly infringe or are repeatedly
      charged with infringing the copyrights or other intellectual property rights of others.
    </p>

    <p>
      In accordance with the Digital Millennium Copyright Act of 1998, the text of which may be
      found on the U.S. Copyright Office website at
      {' '}
      <a
        {...NEW_TAB_ATTRIBUTES}
        href="https://www.copyright.gov/legislation/dmca.pdf"
        className={styles.link}
      >
        https://www.copyright.gov/
        <wbr />
        legislation/
        <wbr />
        dmca.pdf
      </a>
      , Getmyboat will respond expeditiously to claims of copyright infringement committed using the
      Getmyboat website and mobile application (the &quot;Site and Application&quot;) that are
      reported to Getmyboat&apos;s Designated Copyright Agent, identified in the sample notice
      below.
    </p>

    <p>
      If you are a copyright owner, or are authorized to act on behalf of one, or authorized to act
      under any exclusive right under copyright, please report alleged copyright infringements
      taking place on or through the Site and Application by completing the following DMCA Notice of
      Alleged Infringement and delivering it to Getmyboat&apos;s Designated Copyright Agent. Upon
      receipt of the Notice as described below, Getmyboat will take whatever action, in its sole
      discretion, it deems appropriate, including removal of the challenged material from the Site
      and Application.
    </p>

    <p>
      <strong>DMCA Notice of Alleged Infringement (&quot;Notice&quot;)</strong>
    </p>

    <ol>
      <li>
        Identify the copyrighted work that you claim has been infringed, or - if multiple
        copyrighted works are covered by this Notice - you will provide a comprehensive list of the
        copyrighted works that you claim have been infringed.
      </li>
      <li>
        Identify the material that you claim is infringing (or to be the subject of infringing
        activity) and that is to be removed or access to which is to be disabled, and information
        reasonably sufficient to permit us to locate the material, including at a minimum, if
        applicable, the URL of the link shown on the Site and Application where such material may be
        found.
      </li>
      <li>Provide your mailing address, telephone number, and, if available, email address.</li>
      <li>
        Include both of the following statements in the body of the Notice:
        <ul>
          <li>
            &quot;I hereby state that I have a good faith belief that the disputed use of the
            copyrighted material is not authorized by the copyright owner, its agent, or the law
            (e.g., as a fair use).&quot;
          </li>
          <li>
            &quot;I hereby state that the information in this Notice is accurate and, under penalty
            of perjury, that I am the owner, or authorized to act on behalf of the owner, of the
            copyright or of an exclusive right under the copyright that is allegedly
            infringed.&quot;
          </li>
        </ul>
      </li>

      <li>Provide your full legal name and your electronic or physical signature.</li>
    </ol>

    <p>
      Deliver this Notice, with all items completed, to Getmyboat&apos;s Designated Copyright Agent:
    </p>

    <address>
      Data Protection Officer
      <br />
      c/o Getmyboat, Inc.
      <br />
      #1129
      <br />
      101 International Parkway,
      <br />
      Adairsville, Georgia 30103
      <br />
      <a
        {...NEW_TAB_ATTRIBUTES}
        href="mailto:dpo@getmyboat.com"
        className={styles.link}
      >
        dpo@getmyboat.com
      </a>
    </address>

    <p>
      <strong>Photographs. </strong>
      If you choose to use the Getmyboat&apos;s photography service, you agree that Getmyboat will
      own all right, title and interest in and to the copyright rights in the resulting images.
    </p>

    <h3>Member Obligations</h3>

    <p>
      <strong>Registration. </strong>
      Prior to using Services, Member is required to register on the Getmyboat Website, and perform
      all actions necessary to comply with the Getmyboat Website registration requirements and the
      Terms.
    </p>
    <p>
      Responsibility for applicable laws, rules and regulations, some of which, such as tax laws,
      change from time to time and may affect existing bookings Members agree that they are
      responsible for, and agree to abide by, all laws, rules and regulations applicable to a
      booking and their use of the Website, their use of any tool, service or product offered on the
      Website, and any transaction they enter into in connection with their use of the Website.
    </p>
    <p>
      Members further agree that they are responsible for and agree to abide by all laws, rules and
      regulations applicable to the advertisement of boats, the conduct of their rental business,
      and the operation of any boat advertised on the Website, including but not limited to taxes,
      including as set forth herein, permit or license requirements, inspection and safety
      compliance, and verification of Renter identification and travel documentation, as applicable.
      It is the responsibility of the member to: fully vet, train, and make Renters aware of safety
      features, and ensure there is insurance coverage for each rental when acting as a captained
      charter, Members must ensure they meet all local regulations and licensing to act as a
      captained charter.
    </p>

    <h4>Weather Cancellation Policy — Owner Guidelines</h4>
    <p>
      As an owner or operator on Getmyboat, you are responsible for ensuring the safety of your
      guests and crew. Getmyboat does not evaluate or intervene in weather-related decisions.
      You have full discretion to determine whether a trip should proceed, be delayed, rescheduled,
      or canceled due to weather.
    </p>

    <p>
      <strong>You Make the Call. </strong>
      You are expected to monitor local conditions and assess whether the trip can be conducted
      safely. This includes: wind speed and gusts, rain, lightning, or storms, visibility issues,
      and marine advisories or hazard alerts. Your safety assessment should be based on your local
      expertise, vessel capabilities, and experience.
    </p>

    <p>
      <strong>Communicate Clearly and Promptly. </strong>
      If you determine that weather conditions are unsafe, you must: (1) Notify the renter as early
      as possible. If there are early weather warnings, it is recommended that you advise the renter
      that you are monitoring weather conditions; (2) Offer to reschedule the trip at a mutually
      agreeable time; or (3) Cancel the booking and initiate a full refund.
    </p>

    <p>Timely and proactive communication enhances renter trust and helps reduce disputes.</p>

    <p>
      <strong>Important: No Abuse of Weather Policy. </strong>
      Getmyboat supports owner discretion in canceling for safety — but this policy must not be
      used to cancel trips for non-weather-related reasons or to avoid platform penalties. Frequent
      or last-minute cancellations citing &quot;weather&quot; without credible weather data may
      be subject to review.
    </p>

    <p>
      Weather cancellations must align with verifiable local forecasts, marine advisories, or
      conditions as documented by trusted public weather sources (e.g., NOAA, National Weather
      Service, or AccuWeather). In the event of a dispute, Getmyboat will reference publicly
      available weather data from these sources at the time and location of the booking to
      determine if a cancellation was justified.
    </p>

    <p>
      Misuse of this policy — such as canceling for personal scheduling conflicts or renter
      preferences under the guise of weather — may result in account warnings, reduced visibility,
      or penalties. We trust our owners to act in good faith. Abuse of the weather exemption
      undermines renter confidence and the integrity of the marketplace.
    </p>

    <p>
      <strong>Platform Support for Weather Cancellations. </strong>
      When a cancellation is legitimate and safety-based: (1) No penalties or performance
      downgrades will be applied; (2) Getmyboat will support you in processing full refunds
      or rescheduling as applicable; (3) You will not be held liable for weather-related
      changes when communicated properly.
    </p>

    <p>
      <strong>If the Renter Cancels Despite Safe Conditions. </strong>
      If the weather is deemed safe by you and the renter chooses not to proceed, your standard
      cancellation policy applies and you are not obligated to issue a refund beyond those terms.
    </p>

    <p>
      Summary of Key Points: (1) You are responsible for making weather-related safety decisions;
      (2) Cancellations must be made in good faith and supported by real conditions; (3) Getmyboat
      will not penalize legitimate weather cancellations; (4) Repeated misuse of the weather
      exemption may result in action against your account.
    </p>

    <p>
      <strong>Subscription Fees. </strong>
      Members will not be required to pay Getmyboat any joining or initial subscription fee(s)
      related to use of Getmyboat&apos;s Services. Getmyboat, however, reserves the right to charge
      subscription fees at any time and shall notify Members of any changes in subscription fee
      policies. The Payment terms in the Terms of Use are expressly incorporated herein. We charge
      Members a service fee of
      {` ${SERVICE_FEES.OWNER_PERCENT}`}
      % of the total rental (i.e., the booking and any additional
      expenses) for use of the Services. This
      {` ${SERVICE_FEES.OWNER_PERCENT}`}
      % fee and any applicable taxes we collect on the
      rental and related charges will be deducted from the total amount charged to the Renter before
      payment is made to Member (i.e., the payment amount made to Members will be the total rental
      charged to the Renter less
      {` ${SERVICE_FEES.OWNER_PERCENT}`}
      % and the taxes we will be remitting to the applicable
      governmental entity).
    </p>

    <h3>
      AS PROVIDED IN THE TERMS OF USE, ANY DIRECT OR INDIRECT EXCHANGE OF MONEY BETWEEN RENTERS AND
      MEMBERS OTHER THAN PAYMENT THROUGH GETMYBOAT IS A VIOLATION OF THIS AGREEMENT.
    </h3>

    <p>
      <strong>User-Member Communications. </strong>
      You agree that, with respect to other Members&apos; or Users&apos; personal information that
      you obtain directly or indirectly from or through the Website or through any Website-related
      communication, transaction or software, we have granted to you a license to use such
      information only for: (a) Website-related communications that are not unsolicited commercial
      messages, (b) using services offered through the Website, and (c) inquiring about or otherwise
      facilitating a financial transaction between you and the other Member or User related to the
      purpose of the Website (such as inquiring about or booking an on-line rental and transacting
      payment). Any other purpose will require express permission from the User. You may not use any
      such information for any unlawful purpose or with any unlawful intent.
    </p>
    <p>
      In all cases, you must give Users an opportunity to remove themselves from your address book
      or database and a chance to review what information you have collected about them. In
      addition, under no circumstances, except as defined in this provision, may you disclose
      personal information about another Member or User to any third party without both our consent
      and the consent of the Member or User. You agree that other Members or Users may use your
      personal information to communicate with you in accordance with this provision. Further, you
      agree that you will protect Members&apos; or Users&apos; personal information with the same
      degree of care that you protect your own confidential information (using at minimum a
      reasonable standard of care), and you assume all liability for the misuse, loss, or
      unauthorized transfer of such information.
    </p>
    <p>
      <strong>No Spam. </strong>
      We do not tolerate spam or unsolicited commercial electronic communications of any kind.
      Therefore, without limiting the foregoing, you are not licensed to add a Member or User, even
      a User who has rented a boat from you, to your mailing list (e-mail or physical mail) without
      the Member&apos;s or User&apos;s express consent. You may not use any tool or service on the
      Website to send spam or unsolicited commercial electronic communications of any kind or in any
      other way that would violate these Terms. You are responsible for all content you provide to
      the Website or through any tool or service provided on the Website and for your use of any
      personal information of Users you obtain through the Website or otherwise in connection with
      your participation in the Services.
    </p>
    <h3>Content and Layout</h3>
    <p>
      All Content and copy edits submitted by Members are subject to review and approval at
      Getmyboat&apos;s sole discretion. We reserve the right to refuse to publish any Content that
      we determine, in our sole discretion, does not comply with the Terms or is otherwise
      unacceptable to us. However, we assume no duty to review Content and we shall not have any
      liability for any loss or damage resulting from the design or positioning of the copy,
      properties, Content and/or photographs or any change made to any Content, photograph or copy
      submitted by any member. All Content must meet these Terms. We reserve the right to edit
      Content submitted to the Website in a non-substantive manner solely to cause the Content to
      comply with our Content guidelines or formatting requirements. Members are responsible for
      reviewing and ensuring that any Content displayed on the Website appears as the Member
      intended.
    </p>
    <h3>Indemnification</h3>
    <p>
      Member (the &quot;Indemnifying Party&quot;) will defend and indemnify Getmyboat (the
      &quot;Indemnified Party&quot;) against any and all claims, losses, costs and expenses,
      including reasonable attorneys&apos; fees, that the Indemnified Party may incur as a result of
      claims in any form by third parties arising from: (a) the Indemnifying Party&apos;s
      intentional tortious or negligent acts or omissions (including, without limitation,
      noncompliance with any applicable legal and/or regulatory requirements); (b) the Indemnifying
      Party&apos;s breach of any representation, warranty or covenant set forth herein; (c) the
      infringement of any third party&apos;s intellectual property by any trademarks or other
      intellectual property provided by the Indemnifying Party to the Indemnified Party; and (d) the
      Indemnifying Party&apos;s failure to collect all taxes, fees and charges that may be
      applicable to the boat rental services being offered for sale by the Indemnifying Party to the
      extent those taxes were as a result of the Indemnifying Party&apos;s failure to notify the
      Indemnified Party of the change in location of delivery of the boat to the renter and such
      location resulted in a change in applicable taxes (see next section).
    </p>
    <section>
      <h3>Pricing Policy</h3>
      <p>
        As an owner, setting accurate and transparent pricing is essential to ensure a positive
        experience for both you and your renters. This policy outlines your responsibilities
        regarding pricing to maintain fairness, clarity, and professionalism across our platform.
        It also serves to help you comply with the Federal Trade Commission&apos;s Rule on Unfair
        or Deceptive Fees (16 C.F.R. Part 464), which took effect on May 12, 2025. All listings
        must display the total price upfront, including all mandatory fees known at the time of
        listing, such as cleaning, service, or booking fees. Optional fees must be clearly
        identified and disclosed before the renter agrees to pay. While government-imposed taxes may
        be listed separately, they must be disclosed prior to checkout. As the listing owner, you
        are solely responsible for ensuring your pricing complies with all applicable laws and
        regulations. Any non-compliance or resulting enforcement actions will be directed to you.
        Misrepresenting any fee, including its purpose, amount, or refundability, is strictly
        prohibited.
      </p>
      <ol>
        <li>
          <h4>Accurate and Up-to-Date Pricing</h4>
          <p>
            Owners are responsible for ensuring that all listed prices for rentals are accurate
            and current.
          </p>
          <ul>
            <li>
              Regularly review and update your pricing to reflect seasonal rates, market
              trends, and any changes in operational costs.
            </li>
            <li>
              Avoid misleading or placeholder pricing. Listings with inaccurate prices may be
              subject to penalties, removal, or suspension from the platform.
            </li>
          </ul>
        </li>
        <li>
          <h4>Inclusive Pricing Structure</h4>
          <p>Your pricing must include all possible fees that a renter might incur.</p>
          <ul>
            <li>
              <strong>Mandatory fees </strong>
              (e.g., marina fees, fuel costs) must be included in the pricing table, or
              if determined post-trip, indicative fuel cost per hour based on an average
              consumption must be disclosed in the listing description, as well as
              communicated directly to the renter through the messaging platform
              prior to payment.
            </li>
            <li>
              <strong>Optional fees </strong>
              (e.g., additional services, add-ons) may be stated in the listing
              description, but must be clearly marked as optional.
            </li>
          </ul>
          <p>
            Renters should be able to see the full cost of their booking upfront to avoid
            unexpected charges after confirming their reservation.
          </p>
        </li>
        <li>
          <h4>Additional Fees</h4>
          <ul>
            <li>
              All fees and prices must be accurately associated with their cost categories
              (e.g. marina fees, fuel, captains, tips). Prices for items included in your
              total cost breakdown must be accurate and associated correctly for that
              specific item, and that item only. You may not increase the cost of one item
              to cover costs of something else. Charges for specific items must be
              disclosed correctly.
            </li>
            <li>
              Captain fees specifically must be reasonable and proportional to the rental fee
              of the vessel. It should not exceed a fair percentage of the rental fee unless the
              captain&apos;s services are exceptionally unique or in areas where local regulations
              require certified captains at higher rates.
            </li>
            <li>
              Any fees that appear irrationally high compared to the rental fee, in
              Getmyboat&apos;s sole discretion, will be flagged for review.
              Inconsistent or unjustifiable pricing can result in corrective action,
              including listing suspension or removal.
            </li>
          </ul>
        </li>
        <li>
          <h4>Transparent Communication</h4>
          <p>Clear communication about pricing ensures trust and avoids disputes.</p>
          <ul>
            <li>
              Getmyboat uses your pricing table to clearly communicate the full cost of the
              rental on the listing, with no surprise fees post-booking.
            </li>
            <li>
              If changes to pricing are necessary after a booking, these must be clearly
              called out to the renter and agreed upon before proceeding.
            </li>
          </ul>
        </li>
        <li>
          <h4>Consequences for Non-Compliance</h4>
          <p>Failure to adhere to this pricing policy may result in:</p>
          <ul>
            <li>Temporary or permanent suspension of your listing(s).</li>
            <li>Negative reviews from renters, impacting your reputation and bookings.</li>
            <li>Financial penalties if disputes arise due to unclear or inaccurate pricing.</li>
            <li>Search downrank for your listings</li>
            <li>
              Inelligibility for Superowner, &apos;Best of&apos; Status and/or Broadcast Inquiries
            </li>
          </ul>
        </li>
      </ol>
    </section>
    <section>
      <h3>Owner Availability Policy</h3>
      <p>
        To ensure a seamless experience for both owners and guests, it&apos;s essential to maintain
        accurate and up-to-date availability on your listing. This policy outlines the expectations
        for managing your calendar and availability settings to foster trust and provide reliable
        booking experiences.
      </p>
      <p>Availability Policy Guidelines</p>
      <ol>
        <li>
          <h4>Keep Your Calendar Up-to-Date</h4>
          <ul>
            <li>
              Owners must regularly update their availability to reflect accurate dates and
              times when their boat is available for bookings.
            </li>
            <li>
              Block off dates immediately if they become unavailable due to personal use,
              maintenance, or other reasons.
            </li>
          </ul>
        </li>
        <li>
          <h4>Honoring Confirmed Bookings</h4>
          <ul>
            <li>
              Once a reservation is confirmed, owners are expected to honor the booking unless
              extenuating circumstances arise, as per platform policies.
            </li>
          </ul>
        </li>
        <li>
          <h4>Seasonal Updates &amp; Holidays</h4>
          <ul>
            <li>
              Availability and pricing accuracy are even more important for peak booking days
              like weekends, holidays, and busy local events. Be sure to block out days
              immediately to prevent cancellations which will impact your ranking
              in our search results.
            </li>
          </ul>
        </li>
        <li>
          <h4>Consequences for Non-Compliance</h4>
          <p>Failure to adhere to this pricing policy may result in:</p>
          <ul>
            <li>Temporary or permanent suspension of your listing(s).</li>
            <li>Negative reviews from renters, impacting your reputation and bookings.</li>
            <li>
              Financial penalties if disputes arise due to unclear or inaccurate availability.
            </li>
            <li>Search downrank for your listings</li>
            <li>
              Inelligibility for Superowner, &apos;Best of&apos; Status and/or Broadcast Inquiries
            </li>
          </ul>
        </li>
      </ol>
    </section>
    <section>
      <h3>Owner Cancellation Policy</h3>
      <p>
        Maintaining a reliable and trustworthy experience for renters is critical to the Getmyboat
        platform. As an owner, your availability and commitment to confirmed bookings directly
        affect renter satisfaction and platform integrity. While we understand that unexpected
        situations may arise, owners are expected to honor all confirmed bookings unless there is
        a valid and unavoidable reason for cancellation.
      </p>

      <h4>Acceptable Reasons for Cancellation</h4>

      <p>
        Owners may cancel a booking without penalty when due to:
      </p>
      <ul>
        <li>Unsafe weather conditions (see Weather Policy)</li>
        <li>Mechanical or maintenance issues that make the vessel unsafe or unusable</li>
        <li>
          Emergency or force majeure events (serious illness, accident, natural disaster, etc.)
        </li>
      </ul>
      <p>
        These situations should be clearly communicated to the renter and documented when possible.
      </p>

      <h4>Unacceptable or Avoidable Cancellations</h4>
      <p>
        The following reasons are not considered valid and may result in action:
      </p>
      <ul>
        <li>&quot;Scheduling conflicts&quot; or double bookings</li>
        <li>Personal plans or travel</li>
        <li>Forgetting to update availability</li>
        <li>Cancellations with vague or no reason provided</li>
        <li>Cancelling due to a renter inquiry or request not aligning with your preferences</li>
      </ul>

      <p>
        Owners are expected to keep calendars up to date and proactively manage their listings to
        avoid these scenarios.
      </p>

      <h4>Cancellation Timeline &amp; Accountability</h4>
      <p>
        Cancellations made close to the booking date can significantly disrupt a renter&apos;s
        plans. For that reason, owner-initiated cancellations are subject to increasing scrutiny
        based on proximity to the trip:
      </p>
      <ul>
        <li>
          More than 7 days in advance: Avoidable cancellations may trigger a warning or calendar
          management restrictions.
        </li>
        <li>
          Within 7 days of the trip: Repeated or unjustified cancellations may lead to account
          review, reduced search visibility, or temporary suspension.
        </li>
        <li>
          Same-day or within 24 hours of trip start: Unless clearly due to weather or emergency,
          these cancellations will result in a financial penalty of $200 or the full value of
          Getmyboat&apos;s booking fees for the trip, whichever is greater. This amount will be
          recouped from your next payout.
        </li>
      </ul>

      <p>
        Each cancellation is reviewed in context, but Getmyboat reserves the right to take action
        when patterns of unreliability or abuse emerge.
      </p>

      <h4>Reservations Made in Error</h4>
      <p>
        From time to time, renters make mistakes when booking a trip, particularly when they choose
        the wrong day or time. If a reservation was made in error, and cancelled by the renter
        within 24 hours, we will honor a full refund including the trip cost and Getmyboat fees,
        regardless of an owner&apos;s cancellation policy. Getmyboat will, at its sole discretion,
        make the determination of a genuine user error that warrants a full refund. This exception
        is intended for genuine mistakes and will not apply in cases of change of plans or other
        non-error-related reasons.
      </p>

      <h4>Helping Us Help You</h4>
      <p>
        If you must cancel:
      </p>
      <ul>
        <li>Notify the renter and Getmyboat support or account managers immediately</li>
        <li>Explain the reason clearly in your message</li>
        <li>Offer to reschedule when possible</li>
        <li>Document the situation if it involves maintenance or emergency events</li>
      </ul>

      <p>
        Transparency goes a long way in protecting your reputation and renter trust.
      </p>

      <h4>Summary of Expectations:</h4>
      <ul>
        <li>Owners are responsible for honoring all confirmed bookings.</li>
        <li>Legitimate exceptions (weather, maintenance, emergencies) are supported.</li>
        <li>
          Cancellations for avoidable reasons may result in reduced visibility or platform
          restrictions.
        </li>
        <li>Last-minute cancellations face greater scrutiny and financial penalties.</li>
        <li>Communicate early, clearly, and in good faith.</li>
      </ul>

    </section>
    <h3>Taxes</h3>
    <p>
      Commencing with bookings made on and after the date set forth at the top of the first page
      Getmyboat will commence in some jurisdictions to charge and collect from the User all
      applicable state, local taxes or other taxes, including VAT, that Getmyboat is required by law
      to collect which may not include all applicable taxes on the rental amount and other charges
      made to the User through Getmyboat. The collection approach will be implemented over time and
      not it will not be implemented in every jurisdiction on the date noted. Getmyboat will notify
      Members in affected jurisdictions on the date it will commence charging and collecting in the
      jurisdiction that includes the Member&apos;s zip code. Pursuant to this agreement when
      Getmyboat commences collection of such taxes, you instruct and authorize Getmyboat to collect
      such taxes on your behalf, and to remit such taxes to the relevant authority. Any taxes that
      are collected and remitted by Getmyboat will be are identified to Members on their transaction
      records, as applicable. Getmyboat may charge and collect additional amounts from Members
      (including by deducting such amounts from future payouts) in the event that the taxes
      collected and/or remitted are insufficient to fully discharge such Member&apos;s or
      Getmyboat&apos;s tax obligations. You acknowledge and agree that we retain the right, with
      prior notice to affected Members, to cease the collection and remittance of taxes in any
      jurisdiction for any reason.
    </p>
    <p>
      We hereby certify to the Member that we will collect only such amounts that to our knowledge
      Getmyboat is legally required to collect based on the information known to us, and we will
      remit such collected amount to the applicable taxing authority, which may not include all
      other taxes or sums the Member is required to collect and remit. The Member is not to collect
      any taxes from the Renter that Getmyboat collects and, unless otherwise required in the
      jurisdiction that includes the Member&apos;s zip code, should not report them on any sales and
      use tax or other tax return for such jurisdiction such Member otherwise files for other taxes
      collected or remitted on a return for the Member&apos;s other taxable activities in the
      jurisdiction where Getmyboat collects and remits such taxes. Members should collect and remit
      all applicable taxes that are not collected by Getmyboat. Getmyboat will make the
      determination of the applicable amount to be charged based on the zip code of the Member on
      file with Getmyboat unless and until the Member advises Getmyboat in writing of a change in
      the location of where the boat will be delivered to a User. The failure of the Member to
      immediately and timely notify Getmyboat of the actual or planned delivery of possession of the
      boat to a User in a location other than the Member&apos;s zip code will result in the Member
      being liable and obligated to pay or reimburse Getmyboat for any excess taxes, penalties or
      interest that is or will be due on such excess taxes.
    </p>
    <p>
      In certain jurisdictions, the law or regulations may require that we that report information
      about you, or withhold taxes or other amounts from payouts to you, or both. If you fail to
      provide us with documentation that we determine to be sufficient to support any such
      obligation to withhold from payouts to you, we may withhold payouts up to the amount as
      required by law or as we are directed by an applicable governing authority, until sufficient
      documentation is provided. You agree that Getmyboat may issue on your behalf invoices or
      similar documentation to facilitate accurate tax reporting associated with a booking.
    </p>
    <p>
      <strong>Governing Law. </strong>
      The terms of this Agreement shall be construed in accordance with the substantive laws
      of the State of Delaware, United States of America, without giving effect to the
      principles of conflict or choice of law of such state. The original form of this
      Agreement has been written in English. The parties hereto waive any statute, law,
      or regulation that might provide an alternative law or forum or might require this
      Agreement to be written in any language other than English. This Agreement
      expressly excludes the United Nations Convention on Contracts for the International
      Sale of Goods.
    </p>
    <p>
      <strong>Choice of Forum and Venue. </strong>
      You hereby consent to the exclusive jurisdiction and venue of state courts in Cobb
      County of Georgia, U.S.A., or the Northern District Court of Georgia, Atlanta Division,
      in all disputes arising out of the Terms or relating to the use of the Service. All
      arbitration proceedings to be held in Atlanta, Georgia.
    </p>

    <h3>Additional Terms Applicable to Direct Bookings</h3>
    <p>
      <strong>Service Charge. </strong>
      For the Direct Booking Feature, we charge the Member a service fee of 1.5% of the
      total rental with a minimum of a $5 USD service fee (i.e. the booking and any additional
      expenses such as taxes we are required to collect) for facilitating the rental,
      and this amount will be reflected in the final amount charged to Member&apos;s credit
      card. We reserve the right to round up amounts to the nearest whole dollar (for example,
      $202.60 will be rounded to $203). We will process any necessary currency conversion
      (Getmyboat charges in US dollars unless otherwise specified) based upon Renter&apos;s currency
      on the day the credit card is charged and we will charge a conversion fee of 3% of the
      total rental for currency conversions. We reserve the right to adjust the conversion rate
      based upon when the payout is made to the Member. The service fee and any conversion
      fee constitute &quot;Transaction Fees&quot;. Getmyboat reserves the right to adjust its
      Transaction Fees at any time. Any Fee changes will be effective the next time you book a
      rental after such fee change goes into effect (i.e., rentals already booked will
      be subject to Fees as established at the time of booking).
    </p>
    <p>
      <strong>Monitoring. </strong>
      Under direct bookings, the Member is directly bringing the Renter to the Getmyboat site and
      submitting Renter information. Getmyboat is under no obligation to verify or monitor the
      information residing or transmitted to this site for the Direct Booking Feature.
    </p>
    <p>
      You are required to carefully review the information submitted. Getmyboat makes no warranty as
      to the accuracy, completeness or currency of the content. It is your responsibility to verify
      any information before relying on it. The content of this site may include technical
      inaccuracies or typographical errors. From time to time, changes are made to the
      content herein.
    </p>
    <p>
      <strong>Limitation of Liability. </strong>
      You assume all responsibility and risk for the use of Direct Bookings. In no event shall
      Getmyboat, be liable for any direct, special, indirect, or consequential damages or any
      damages whatsoever; including but not limited to loss of use, data or content, and
      transaction conducted through or facilitated by the site, any claim attributable to
      errors, omissions or other inaccuracies in the site, the service and or the content,
      unauthorized access to or alteration of your transmissions or data, or any other matter
      relating the site and or the service.
    </p>
    <p>
      <strong>Terminate or Restrict Access. </strong>
      Getmyboat have the right to terminate or restrict access to any or all of this Direct
      Booking Feature, unilaterally and without notice, in its sole discretion. Getmyboat
      also reserves any and all remedies at law or equity in connection with violation
      of these Terms of Use.
    </p>
  </main>
);

export default MemberAgreement;
